/**
 * @generated SignedSource<<8dafbc49d3e6cb39fe49018eb71c0238>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedHeroCarousel_item$data = {
  readonly firstPhotoWebPath: string | null;
  readonly hasPrivateListing: boolean | null;
  readonly seller: {
    readonly isAccessible: boolean | null;
  } | null;
  readonly serviceId: string | null;
  readonly sortedPhotos: ReadonlyArray<{
    readonly __typename: "ItemPhoto";
    readonly alt: string | null;
    readonly largePath: string | null;
    readonly masterOrZoomPath: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"CarouselThumb_sortedPhoto" | "Image_sortedPhoto" | "useItemMediaItems_sortedPhotos">;
  } | null> | null;
  readonly title: string | null;
  readonly videoVimeo: {
    readonly fileByVideoSize: {
      readonly link: string | null;
    } | null;
    readonly thumbnail: string | null;
    readonly vimeoId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"CarouselThumb_videoVimeo" | "VimeoVideo_videoVimeo" | "useItemMediaItems_videoVimeo">;
  } | null;
  readonly viewInRoomPhotos: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"CarouselThumb_viewInRoomPhoto" | "ViewInRoom_viewInRoomPhoto" | "useItemMediaItems_viewInRoomPhotos">;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"Image_item" | "RequestMoreImages_item" | "ViewInRoom_item" | "useItemMediaItems_item">;
  readonly " $fragmentType": "PdpRespSharedHeroCarousel_item";
};
export type PdpRespSharedHeroCarousel_item$key = {
  readonly " $data"?: PdpRespSharedHeroCarousel_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedHeroCarousel_item">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "size",
    "value": "small"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedHeroCarousel_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemMediaItems_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Image_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ViewInRoom_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RequestMoreImages_item"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "sortedPhotos",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useItemMediaItems_sortedPhotos"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CarouselThumb_sortedPhoto"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Image_sortedPhoto"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "masterOrZoomPath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "largePath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "alt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VideoVimeo",
      "kind": "LinkedField",
      "name": "videoVimeo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useItemMediaItems_videoVimeo"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CarouselThumb_videoVimeo"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "VimeoVideo_videoVimeo"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "includePlayButton",
              "value": false
            },
            {
              "kind": "Literal",
              "name": "pad",
              "value": false
            },
            {
              "kind": "Literal",
              "name": "size",
              "value": "w100h75"
            }
          ],
          "kind": "ScalarField",
          "name": "thumbnail",
          "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w100h75\")"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vimeoId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v0/*:: as any*/),
          "concreteType": "VideoVimeoFile",
          "kind": "LinkedField",
          "name": "fileByVideoSize",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "link",
              "storageKey": null
            }
          ],
          "storageKey": "fileByVideoSize(size:\"small\")"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "viewInRoomPhotos",
      "kind": "LinkedField",
      "name": "viewInRoomPhotos",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useItemMediaItems_viewInRoomPhotos"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CarouselThumb_viewInRoomPhoto"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ViewInRoom_viewInRoomPhoto"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPrivateListing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*:: as any*/),
      "kind": "ScalarField",
      "name": "firstPhotoWebPath",
      "storageKey": "firstPhotoWebPath(size:\"small\")"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "8a28f84410c924eb7262dff930ee4b6a";

export default node;
